<template>
  <div id="home" class="d-flex flex-column" style="height: 100vh;">
    <BsHeaderView @toggle="menuToggle"></BsHeaderView>
    <div class="flex-grow-1 d-flex flex-column overflow-hidden position-relative main-container">
      <div class="content-wrapper d-flex flex-grow-1">
        <div class="sidebar-container" :class="{ 'd-none': !menuDisplay }">
          <bs-side-menu-view :display-sw="menuDisplay"></bs-side-menu-view>
        </div>
        <div
          class="main-content-container"
          :class="menuDisplay ? 'with-sidebar' : 'full-width'"
        >
          <router-view></router-view>
        </div>
      </div>
      <BsFooterView></BsFooterView>
    </div>
  </div>
</template>
<style>
#home {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-container {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.content-wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}

.sidebar-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16.66667%;
  overflow: hidden;
  z-index: 100;
}

.main-content-container {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  overflow-y: auto;
  padding: 20px;
}

.with-sidebar {
  left: 16.66667%;
  width: 83.33333%;
}

.full-width {
  left: 0;
  width: 100%;
}

.table tbody tr td {
  vertical-align: middle !important;
}

@media (max-width: 767.98px) {
  .sidebar-container {
    width: 100%;
  }
  
  .with-sidebar {
    left: 0;
    width: 100%;
  }
}
</style>
<script>
// import Vue from 'vue'
import BsHeaderView from '../organisms/BsHeaderView.vue'
import BsFooterView from '../organisms/BsFooterView.vue'
import BsSideMenuView from '../organisms/BsSideMenuView.vue'
import { mapState } from 'vuex'
// import config from '../../const'
// import axios from 'axios'
export default {
  name: 'templateTerminalView',
  data: function () {
    return {
      menuDisplay: true
    }
  },
  computed: {
    ...mapState({}),
    mainDisplayClass() {
      if (this.menuDisplay) {
        return 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
      } else {
        return 'col-md-12 ms-sm-auto col-lg-12 px-md-4'
      }
    }
  },
  components: {
    BsHeaderView,
    BsFooterView,
    BsSideMenuView
  },
  created() {},
  methods: {
    menuOpen() {},
    menuToggle() {
      console.log('toggle !!')
      if (this.menuDisplay) {
        this.menuDisplay = false
      } else {
        this.menuDisplay = true
      }
    }
  }
}
</script>

<style>
@import '../../assets/bootstrap/css/dashboard.css';
</style>
